import LogoIcon from "~icons/local/logo";
import ProfileIcon from "~icons/local/profile";
import RfqsIcon from "~icons/local/rfqs";
import CustomersIcon from "~icons/local/customers";
import HelpIcon from "~icons/local/help";
import SettingsIcon from "~icons/local/settings";
import { getUrl } from "@/lib/useToPage";
import CrispContext from "../crisp/CrispContext";
import { ReactNode, useContext } from "react";
import { NavLink, useParams } from "react-router";
import { components } from "../ApiSchema";
import { canAccessSettings } from "../utils";
import classNames from "classnames";

export default function NavMain({
  user,
}: {
  user: components["schemas"]["LoggedInUserSchema"];
}) {
  const { crisp, isChatOpened } = useContext(CrispContext);
  const { teamSlug } = useParams();
  const userWithCustomAvatar = user && !user.avatar_url.includes("gravatar");

  return (
    <nav className="min-w-20 pb-4 pt-2 flex flex-col justify-between border-r border-r-slate-300">
      <div className="flex flex-col items-center gap-4">
        <Item icon={<LogoIcon className="size-15 m-auto" />} href="/" />
        <Item
          label="RFQs"
          icon={<RfqsIcon className="h-6 m-auto" />}
          href={getUrl("rfqs", { teamSlug })}
        />
        <Item
          label="Customers"
          icon={<CustomersIcon className="h-6 m-auto" />}
          href={getUrl("organizations", { teamSlug })}
        />
      </div>
      <div className="flex flex-col items-center gap-4">
        {canAccessSettings(user, teamSlug) && (
          <Item
            label="Settings"
            icon={<SettingsIcon className="h-6 m-auto" />}
            href={getUrl("settings", { teamSlug })}
          />
        )}
        <Item
          label="Help"
          icon={<HelpIcon className="h-6 m-auto" />}
          onClick={() => {
            if (isChatOpened) {
              crisp.chat.close();
            } else {
              crisp.chat.open();
            }
          }}
        />
        <Item
          label="Profile"
          icon={
            userWithCustomAvatar ? (
              <img
                src={user.avatar_url}
                className="rounded-full h-8 m-auto"
                draggable={false}
              />
            ) : (
              <ProfileIcon className="h-6 m-auto" />
            )
          }
          href={getUrl("profile", { teamSlug })}
        />
      </div>
    </nav>
  );
}

function Item({
  href,
  label,
  icon,
  onClick = () => {},
}: {
  href?: string;
  label?: string;
  icon: ReactNode;
  onClick?: () => void;
}) {
  const home = href === "/";

  return (
    <NavLink
      className={({ isActive }) =>
        classNames("flex flex-col items-center group", {
          "is-active font-bold": isActive && !!href,
        })
      }
      onClick={onClick}
      to={href ?? "#"}
    >
      <div
        className={classNames("rounded-4xl w-16 flex", {
          "group-hover:bg-blue-100 py-2 group-[.is-active]:bg-blue-100": !home,
        })}
      >
        {icon}
      </div>
      {label && <div className="text-xs mt-1.5">{label}</div>}
    </NavLink>
  );
}
